// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import "swiper/css/bundle";
import Swiper from "swiper/bundle";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

import "./two-col-slider.scss";

const twoColSlider = () => {
    let allTwoColSlider = document.querySelectorAll(".two-col-slider");

    if (!allTwoColSlider.length) return;

    allTwoColSlider.forEach((el, i) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");

        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let args = {
            slidesPerView: 1,
            breakpoints: {
                0: { spaceBetween: 24, slidesPerView: 1.2 },
                500: { spaceBetween: 24, slidesPerView: 1.6 },
                768: { spaceBetween: 30, slidesPerView: 2.1 },
                1024: { spaceBetween: 30, slidesPerView: 2.1 },
                1222: { spaceBetween: 30, slidesPerView: 2.4 },
                1440: { spaceBetween: 30, slidesPerView: 3.1 },
            },
            spaceBetween: 30,
            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination: {
                el: pagination,
                clickable: true,
                dynamicBullets: true,
                type: typePagination,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        };

        new Swiper(el.querySelector(".swiper-container"), args);
    });
};

export default twoColSlider;
